import { baseAuthStyles, AuthStyles } from "../../base/authStyles";

export const customerAuthStyles: AuthStyles = {
  // ...baseAuthStyles,

  input: {
    normal: {
      border: "1px solid #E9E9E9",
      borderRadius: "12px",
      padding: "12px 16px",
      height: "48px",
      fontSize: "14px",
      textAlign: "left" as const,
      lineHeight: "135%",
      color: "#0B0E10",
      bgColor: "white",
      boxShadow: "none",
    },
    error: {
      border: "1px solid #EF4444",
      borderRadius: "12px",
      padding: "12px 16px",
      height: "48px",
      fontSize: "14px",
      textAlign: "left" as const,
      lineHeight: "135%",
      color: "#0B0E10",
      bgColor: "white",
      boxShadow: "none",
    },
    placeholder: {
      color: "#999999",
      fontSize: "14px",
      textAlign: "left" as const,
    },
    placeholderError: {
      color: "#EF4444",
      fontSize: "14px",
      textAlign: "left" as const,
    },
  },

  colors: {
    ...baseAuthStyles.colors,
    buttonBg: "#4285F4",
    textColor: "navy.700",
    textColorBrand: "#155EEF",
    borderColor: "#E9E9E9",
    googleBg: "white",
    googleText: "navy.700",
  },

  container: {
    ...baseAuthStyles.container,
    maxW: "453px",
    borderRadius: "16px",
    bgColor: "#F5F7FA",
    border: "1px solid #E6ECF3",
  },

  heading: {
    fontFamily: "General Sans",
    fontWeight: "600",
    fontSize: "24px",
    lineHeight: "135%",
    textAlign: "center" as const,
  },

  button: {
    ...baseAuthStyles.button,
    primary: {
      ...baseAuthStyles.button.primary,
      fontSize: "16px",
      fontWeight: "600",
      borderRadius: "24px",
      padding: "12px 24px",
    },
    google: {
      ...baseAuthStyles.button.google,
      borderRadius: "8px",
      border: "1px solid #E9E9E9",
      height: "48px",
      fontSize: "14px",
      fontWeight: "400",
    },
  },

  formControl: {
    ...baseAuthStyles.formControl,
    errorMessage: {
      ...baseAuthStyles.formControl.errorMessage,
      color: "#D32F2F",
      bgColor: "#FFE5E5",
      padding: "8px 12px",
      borderRadius: "6px",
      fontSize: "13px",
    },
  },

  alert: {
    error: {
      bgColor: "#FFE5E5",
      color: "#D32F2F",
      borderRadius: "8px",
      padding: "12px 16px",
      fontSize: "14px",
    },
  },

  separator: {
    ...baseAuthStyles.separator,
    fontSize: "14px",
    color: "#0B0E10",
  },

  padding: {
    desktop: {
      form: "32px",
      footer: "24px 32px",
    },
    mobile: {
      form: "24px 20px",
      footer: "16px 20px",
    },
  },

  passwordValidation: {
    container: {
      bg: "#FEF2F2",
      borderRadius: "8px",
      padding: "12px 16px",
      mt: "14px",
    },
    title: {
      fontFamily: "General Sans",
      fontSize: "14px",
      fontWeight: "400",
      color: "#0B0E10",
      marginBottom: "8px",
    },
    errorText: {
      fontFamily: "General Sans",
      fontSize: "14px",
      fontWeight: "400",
      color: "#B91C1C",
    },
  },
};

export default customerAuthStyles;
